import { SwipeableInteractionCard } from "@/common/SwipeableInteractionCard";
import { UserInteractionSpotCard } from "@/common/UserInteractionSpotCard";
import { Button } from "@/components/ui/button";
import { InteractionItemQueryResponse } from "@/generatedApi/userUserInteractionLoggerApi";

type InteractionListContentProps = {
  data: InteractionItemQueryResponse | undefined;
  isLoading: boolean;
  error: any;
  emptyMessage: string;
  enableSwipe?: boolean;
  pageType?: "saved" | "visited";
  onInteractionChange?: () => void;
  onRetry?: () => void;
};

export const InteractionListContent = ({
  data,
  isLoading,
  error,
  emptyMessage,
  enableSwipe = false,
  pageType,
  onInteractionChange,
  onRetry
}: InteractionListContentProps) => {
  return (
    <div className="grid gap-2">
      {isLoading ? (
        <div className="flex h-96 flex-col items-center justify-center gap-4">
          <img src="/logo-icon.svg" className="h-12 w-12 animate-bounce" />
          <span className="">読み込み中</span>
        </div>
      ) : error ? (
        <div className="flex h-96 flex-col items-center justify-center gap-4">
          <div className="text-center">
            <div className="text-lg">😔 読み込みエラー</div>
            <div className="mt-2 text-sm text-gray-500">データの取得に失敗しました</div>
          </div>
          {onRetry && (
            <Button variant="outline" onClick={onRetry}>
              再読み込み
            </Button>
          )}
        </div>
      ) : data?.items?.length ? (
        data.items.map((item) =>
          enableSwipe && pageType ? (
            <SwipeableInteractionCard
              key={item.interaction_id}
              interactionItem={item}
              pageType={pageType}
              onInteractionChange={onInteractionChange}
            />
          ) : (
            <UserInteractionSpotCard key={item.interaction_id} interactionItem={item} />
          )
        )
      ) : (
        <div className="flex h-96 flex-col items-center justify-center gap-4">
          <span>{emptyMessage}</span>
        </div>
      )}
    </div>
  );
};
